export const GET_CURRENT_USER_INFO =
  "[current user] get the current user's info";
export const PROCESS_CURRENT_USER_INFO =
  "[current user] process the current user's info";
export const UPDATE_CURRENT_USER_INFO =
  "[current user] update the current user's info";
export const PROCESS_UPDATED_CURRENT_USER_INFO =
  "[current user] process the updated current user's info";
export const CURRENT_USER_ERROR =
  "[current user] there was an error with the current user's info";
export const CURRENT_USER_LOGOUT = '[current user] log out current user';

export const getCurrentUserInfo = (navigate) => ({
  type: GET_CURRENT_USER_INFO,
  payload: navigate,
});
export const processCurrentUserInfo = (payload) => ({
  type: PROCESS_CURRENT_USER_INFO,
  payload,
});

export const updateCurrentUserInfo = () => ({
  type: UPDATE_CURRENT_USER_INFO,
});

export const currentUserLogout = (navigate) => ({
  type: CURRENT_USER_LOGOUT,
  payload: navigate,
});
